@if (post) {
    <div [@zoom]="zoomState" class="wrapper" (click)="showArticle()">
        <div class="layer"></div>
        <div class="container">
            <img blogTileImage [post]="post" [size]="size" [breakpoint]="breakpoint" class="img" />
            <div
                [@hoverUnhover]="{
                    value: isHovered ? state : 'unhover',
                    params: { titleBottom: titleBottom, titleTop: titleTop },
                }"
                class="title-wrapper"
            >
                <div>
                    <blog-tags
                        [class.single-line-tags]="size === 's'"
                        [tags]="tags"
                        [mouseHoveringParent]="isHovered"
                        (clickTag)="onTagClicked($event)"
                    ></blog-tags>
                </div>
                <span class="title" [style.font-size]="fontSizeTitle" [innerHTML]="post.headline"></span>
            </div>
            <div [@hoverUnhover]="isHovered ? 'fadeIn' : 'fadeOut'" class="sub-title-wrapper">
                <div>
                    <sew-markdown
                        ws
                        [markdown]="textHover | truncate: [120, '...'] | replaceLinebreak"
                    ></sew-markdown>
                </div>
                <p></p>
                <span>{{ authorName + ' | ' + date }}</span>
            </div>
        </div>
    </div>
}
